import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

/**
 * Funcionalidade: Empresas
 * Retorna empresas e cargos cadastrados (suporta paginação e busca)
 * @requestType GET
 * @param {*} agentId
 * @param {{ paginated?: boolean, page?: number, perPage?: number, search?: string }} [options]
 * @returns json | { data: any[], total?: number, meta?: { total?: number } }
 */
export const getEmployerAndRoleList = (agentId, options = {}) => {
  const { paginated = false, page, perPage, search } = options || {};

  const params = {
    agent_id: agentId,
    ...(paginated ? { paginated: true } : {}),
    ...(page != null ? { page } : {}),
    ...(perPage != null ? { per_page: perPage } : {}),
    ...(search ? { search } : {}),
  };

  return http.get('/employers', { params }).then(handleResponse);
};

/**
 * Funcionalidade: Empresas
 * Cria uma nova empresa no sistema
 * @requestType POST
 * @param {*} newEmployer
 * @returns json
 */
export const createNewEmployer = (newEmployer) =>
  http.post('/employers/create', newEmployer);

/**
 * Funcionalidade: Empresas
 * Atualiza uma empresa do sistema
 * @requestType PUT
 * @param {*} employerId
 * @param {*} updatedEmployerInfo
 * @returns json
 */
export const updateEmployer = async (employerId, updatedEmployerInfo) => {
  try {
    const { data } = await http.put(
      `/employers/${employerId}/update`,
      updatedEmployerInfo,
    );
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

/**
 * Funcionalidade: Empresas
 * Lista atividades de contatos por empresa
 * @requestType GET
 * @param {*} parameters
 * @returns json
 */
export const getEmployerHistory = (parameters) =>
  http.get('/employers/history', { params: parameters });

export const getEmployerByName = (search, agent_id) =>
  http.post(`/employers/search?agent_id=${agent_id}&page=1&per_page=10`, {
    employer_name: search,
  });

/**
 * Funcionalidade: Empresas
 * Retorna a empresa e os cargos cadastrados pelo id da empresa
 * @requestType GET
 * @param {*} employer_id
 * @returns json
 */
export const getEmployerAndRolesById = (employer_id) =>
  http.get(`/employers/${employer_id}`).then(handleResponse);
